export const configFieldsRequested = [
  {
    key: 'created_at',
    label: 'Tanggal Unggah',
    thStyle: {
      fontSize: '13px',
      minWidth: '160px',
      textAlign: 'left',
    },
    thClass: 'align-middle font-medium',
    tdClass: 'align-middle',
  },
  {
    key: 'city',
    label: 'Kabupaten/Kota',
    thStyle: {
      fontSize: '13px',
      minWidth: '160px',
      textAlign: 'left',
    },
    thClass: 'align-middle font-medium',
    tdClass: 'align-middle font-medium text-dark',
  },
  {
    key: 'note',
    label: 'Keterangan',
    thStyle: {
      fontSize: '13px',
      minWidth: '140px',
      textAlign: 'left',
    },
    thClass: 'align-middle font-medium',
    tdClass: 'align-middle text-muted',
  },
  {
    key: 'uploaded_by',
    label: 'Diunggah Oleh',
    thStyle: {
      fontSize: '13px',
      minWidth: '140px',
      textAlign: 'left',
    },
    thClass: 'align-middle font-medium',
    tdClass: 'align-middle text-dark',
  },
  {
    key: 'status',
    label: 'Status',
    thStyle: {
      fontSize: '13px',
      minWidth: '130px',
      textAlign: 'center',
    },
    thClass: 'align-middle font-medium text-center',
    tdClass: 'align-middle text-center',
  },
  {
    key: 'coverage_excel_url',
    label: 'Aksi',
    thStyle: {
      fontSize: '13px',
      minWidth: '90px',
      textAlign: 'center',
    },
    thClass: 'align-middle font-medium text-center',
    tdClass: 'align-middle text-center',
  },
]

export const configFieldsSArea = [
  {
    key: 'city',
    label: 'Nama Kabupaten/Kota',
    thStyle: {
      fontSize: '13px',
      minWidth: '200px',
      textAlign: 'left',
    },
    thClass: 'align-middle font-medium text-left',
    tdClass: 'align-middle text-left font-medium text-dark',
  },
  {
    key: 'action',
    label: 'Aksi',
    thStyle: {
      fontSize: '13px',
      minWidth: '150px',
      textAlign: 'right',
    },
    thClass: 'align-middle font-medium text-right',
    tdClass: 'align-middle text-right',
  },
]

export const listProvince = [
  { id: 1, label: 'NUSA TENGGARA BARAT (NTB)' },
  { id: 2, label: 'MALUKU' },
  { id: 3, label: 'KALIMANTAN SELATAN' },
  { id: 4, label: 'KALIMANTAN TENGAH' },
  { id: 5, label: 'JAWA BARAT' },
  { id: 6, label: 'BENGKULU' },
  { id: 7, label: 'KALIMANTAN TIMUR' },
  { id: 8, label: 'KEPULAUAN RIAU' },
  { id: 9, label: 'NANGGROE ACEH DARUSSALAM (NAD)' },
  { id: 10, label: 'DKI JAKARTA' },
  { id: 11, label: 'BANTEN' },
  { id: 12, label: 'JAWA TENGAH' },
  { id: 13, label: 'JAMBI' },
  { id: 14, label: 'PAPUA' },
  { id: 15, label: 'BALI' },
  { id: 16, label: 'SUMATERA UTARA' },
  { id: 17, label: 'GORONTALO' },
  { id: 18, label: 'JAWA TIMUR' },
  { id: 19, label: 'DI YOGYAKARTA' },
  { id: 20, label: 'SULAWESI TENGGARA' },
  { id: 21, label: 'NUSA TENGGARA TIMUR (NTT)' },
  { id: 22, label: 'SULAWESI UTARA' },
  { id: 23, label: 'SUMATERA BARAT' },
  { id: 24, label: 'BANGKA BELITUNG' },
  { id: 25, label: 'RIAU' },
  { id: 26, label: 'SUMATERA SELATAN' },
  { id: 27, label: 'SULAWESI TENGAH' },
  { id: 28, label: 'KALIMANTAN BARAT' },
  { id: 29, label: 'PAPUA BARAT' },
  { id: 30, label: 'LAMPUNG' },
  { id: 31, label: 'KALIMANTAN UTARA' },
  { id: 32, label: 'MALUKU UTARA' },
  { id: 33, label: 'SULAWESI SELATAN' },
  { id: 34, label: 'SULAWESI BARAT' },
]
